export enum StorageE {
  IdToken = 'idToken',
  RefreshToken = 'refreshToken',
  LocationStore = 'locationStore',
  LatestReleaseNoteId = 'latestReleaseNoteId',
  IsLatestReleaseNoteDismissed = 'isLatestReleaseNoteDismissed',
  SavedRoofTops = 'savedRoofTops',
}
